import firebase from "firebase/compat/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  appId: "1:819706945674:web:357aeb0fec8631e86c8d73",
  apiKey: "AIzaSyCv9xBeMLZxww3X3JEUF3RHzQYuXPH7v6k",
  authDomain: "animevoting-f1563.firebaseapp.com",
  databaseURL: "https://animevoting-f1563-default-rtdb.firebaseio.com",
  projectId: "animevoting-f1563",
  storageBucket: "animevoting-f1563.firebasestorage.app",
  messagingSenderId: "G-819706945674",
};

const animeParliament = firebase.initializeApp(firebaseConfig, 'animevoting');

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(animeParliament);
    }
    console.log('AnimeFirebase not supported this browser');
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();
export const db = getFirestore(animeParliament);
export const auth = getAuth();
export const functions = getFunctions(getApp());
export const storage = getStorage();
export const assignAnimeParliament = httpsCallable(functions, "assignReferrer");
export default animeParliament;
